import gql from 'graphql-tag';

import oneDriveRemoteItemsPageFragment from '../fragments/oneDriveRemoteItemsPageFragment';

export const queryOneDriveRemoteItemsPage = gql`
  query oneDriveRemoteItemsPage(
    $credentialID: DokkioID!
    $parentFolderRemoteID: String
    $token: String
  ) {
    oneDriveRemoteItemsPage(
      credentialID: $credentialID
      parentFolderRemoteID: $parentFolderRemoteID
      token: $token
    ) {
      ...oneDriveRemoteItemsPageFragment
    }
  }
  ${oneDriveRemoteItemsPageFragment}
`;

export default queryOneDriveRemoteItemsPage;
